// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__3dfrg","item":"PaymentsMobile_item__mbsv4","label":"PaymentsMobile_label__2QNyR","amount":"PaymentsMobile_amount__2vMFm"};